import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {gqlCmsCopy} from '../getCmsCopy.api';
import {CmsCopy} from '../../../graphql/common.datatypes';

export interface CreateCmsCopyInput {
    data: {
        key: string
        body: string
    }
}

interface CreateCmsCopyData {
    createCmsCopy: CmsCopy
}

export const CREATE_CMS_COPY_MUTATION = gql`
    mutation createCmsCopy($data: CreateCmsCopyInput!) {
        createCmsCopy(data: $data) {
            ${gqlCmsCopy}
        }
    }
`;

export const createCmsCopy = () => useMutation<CreateCmsCopyData, CreateCmsCopyInput>(
    CREATE_CMS_COPY_MUTATION,
    {
        update: updateCacheByType('CmsCopy'),
    }
);

export default createCmsCopy;